import { render } from "./organisation_section_18a.html?vue&type=template&id=5216e0a4&external"
import script from "./organisation_section_18a.js?vue&type=script&lang=js&external"
export * from "./organisation_section_18a.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__